/* eslint-disable */
import { Component, Vue } from "vue-property-decorator";
import { API_ENDPOINT } from "@/constants";
import { Getter } from "vuex-class";
import AdcontrolProfile from "@/models/AdcontrolProfile";
import JsFileDownloader from "js-file-downloader";

@Component
export default class InvestorsMixin extends Vue {
  @Getter("profile") mixinUserProfile!: AdcontrolProfile;
  @Getter("auth/accessToken") readonly token!: string;

  getChartEntries(groupBy: string, data: any, tag: string) {
    const url = API_ENDPOINT + `/investors/chart_entries/${groupBy}.json`;
    if (this.mixinUserProfile?.slug) {
      data.profile = this.mixinUserProfile.slug;
    }
    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "POST",
      data: data,
    });
  }

  getComparisons(group: number, data: any, tag: string) {
    const url = API_ENDPOINT + `/investors/comparisons/${group}.json`;
    if (this.mixinUserProfile?.slug) {
      data.profile = this.mixinUserProfile.slug;
    }
    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "POST",
      data: Object.assign({}, data),
    });
  }

  getComparisonsKPIs(group: number, data: any, tag: string) {
    const url = API_ENDPOINT + `/investors/comparisons/${group}/kpis.json`;
    if (this.mixinUserProfile?.slug) {
      data.profile = this.mixinUserProfile.slug;
    }
    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "POST",
      data: data,
    });
  }

  getComparisonsInline(data: any, tag: string) {
    const url = API_ENDPOINT + `/investors/comparisons/inline.json`;

    if (this.mixinUserProfile?.slug) {
      data.profile = this.mixinUserProfile.slug;
    }
    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "POST",
      data: data,
    });
  }

  getComparisonsBenchmark(group: number, data: any, tag: string) {
    const url = API_ENDPOINT + `/investors/comparisons/${group}/benchmark`;
    if (this.mixinUserProfile?.slug) {
      data.profile = this.mixinUserProfile.slug;
    }
    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "POST",
      data: Object.assign({}, data, { include: "*.companies,*.brands" }),
    });
  }

  getComparisonsBenchmarkKPIs(group: number, data: any, tag: string) {
    const url = API_ENDPOINT + `/investors/comparisons/${group}/benchmark_kpis`;
    if (this.mixinUserProfile?.slug) {
      data.profile = this.mixinUserProfile.slug;
    }
    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "POST",
      data: data,
    });
  }

  getSubEntryPartition(group: number, data: any, tag: string) {
    const url = API_ENDPOINT + `/investors/comparisons/inline.json`;
    if (this.mixinUserProfile?.slug) {
      data.profile = this.mixinUserProfile.slug;
    }
    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "POST",
      data: data,
    });
  }

  getBroadcastersBreakdown(data: any, tag: string) {
    const url = API_ENDPOINT + `/investors/broadcasters/breakdown.json`;

    if (this.mixinUserProfile?.slug) {
      data.profile = this.mixinUserProfile.slug;
    }
    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "POST",
      data: data,
    });
  }

  getCircuitsBreakdown(data: any, tag: string) {
    const url = API_ENDPOINT + `/investors/circuits/breakdown.json`;

    if (this.mixinUserProfile?.slug) {
      data.profile = this.mixinUserProfile.slug;
    }
    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "POST",
      data: data,
    });
  }

  productTimePointsExport(id: string, data: any, filename: string) {
    const url =
      API_ENDPOINT + `/investors/radio/product_time_points/${id}/export`;

    if (this.mixinUserProfile?.slug) {
      data.profile = this.mixinUserProfile.slug;
    }

    return new JsFileDownloader({
      url,
      method: "POST",
      contentType: "application/json",
      headers: [
        {
          name: "Authorization",
          value: `Bearer ${this.token}`,
        },
      ],
      body: JSON.stringify(data),
      filename: `${filename}.csv`,
    });
  }
}
